import { axiosInstance } from 'app/utils/axiosConfig'
import { User } from 'EstraSponsor'

import { endpoints } from './endpoints'

export type ResendConfirmUserEmailPayload = {
  api_v1_user: {
    email: string
  }
}

export type ResendConfirmUserEmailResponse = User

export const resendConfirmUserEmail = async (
  data: ResendConfirmUserEmailPayload
): Promise<ResendConfirmUserEmailResponse> => {
  return axiosInstance.post(endpoints.resendConfirmUserEmail, data)
}
